<template>
  <div>

    <!-- Content Row -->
    <div class="vx-row"> 
      <div class="vx-col md:w-1/2 w-full">
         <vs-input class="w-full mt-4" label="* 학원명" v-model="institute_data.instituteName" v-validate="'required'" name="instituteName" />
        <span class="text-danger text-sm" v-show="errors.has('instituteName')">{{ errors.first('instituteName') }}</span>

        <vs-input class="w-full mt-4" label="* 캠퍼스 명칭" v-model="institute_data.campusName" v-validate="'required'" name="campusName" />
        <span class="text-danger text-sm" v-show="errors.has('campusName')">{{ errors.first('campusName') }}</span>

        <vs-input class="w-full mt-4" label="* 사업자명" v-model="institute_data.contractorName" v-validate="'required'" name="contractorName" />
        <span class="text-danger text-sm" v-show="errors.has('contractorName')">{{ errors.first('contractorName') }}</span>

        <vs-input class="w-full mt-4" label="* 사업자와의 관계" v-model="institute_data.contractorRelation" v-validate="'required'" name="contractorRelation" />
        <span class="text-danger text-sm" v-show="errors.has('contractorRelation')">{{ errors.first('contractorRelation') }}</span>

        <vs-input class="w-full mt-4" label="* 학원장명" v-model="institute_data.presidentName" v-validate="'required'" name="presidentName" />
        <span class="text-danger text-sm" v-show="errors.has('presidentName')">{{ errors.first('presidentName') }}</span>

        <vs-input class="w-full mt-4" label="* 사업자와의 관계" v-model="institute_data.presidentRelation" v-validate="'required'" name="presidentRelation" />
        <span class="text-danger text-sm" v-show="errors.has('presidentRelation')">{{ errors.first('presidentRelation') }}</span>

        <vs-input class="w-full mt-4" label="* 사업자번호" v-model="institute_data.businessNumber" v-validate="'required'" name="businessNumber" />
        <span class="text-danger text-sm" v-show="errors.has('businessNumber')">{{ errors.first('businessNumber') }}</span>

        <vs-input class="w-full mt-4" label="* 전화 번호" v-model="institute_data.telephone" v-validate="'required'" name="telephone" />
        <span class="text-danger text-sm" v-show="errors.has('telephone')">{{ errors.first('telephone') }}</span>

        <vs-input class="w-full mt-4" label="* 이동전화번호" v-model="institute_data.mobilephone " v-validate="'required'" name="mobilephone" />
        <span class="text-danger text-sm" v-show="errors.has('mobilephone')">{{ errors.first('mobilephone') }}</span>

        <vs-input class="w-full mt-4" label="팩스 번호" v-model="institute_data.fax" name="fax" />
        <span class="text-danger text-sm" v-show="errors.has('fax')">{{ errors.first('fax') }}</span>

        <vs-input class="w-full mt-4" label="* 대표이메일" v-model="institute_data.eMail" type="email" v-validate="'required|email'" name="eMail" />
        <span class="text-danger text-sm" v-show="errors.has('eMail')">{{ errors.first('eMail') }}</span>

      </div>

      <div class="vx-col md:w-1/2 w-full">  
        <vs-input class="w-full mt-4" label="* 학원장ID" v-model="institute_data.instituteChiefID" v-validate="'required'" name="instituteChiefID" />
        <span class="text-danger text-sm" v-show="errors.has('instituteChiefID')">{{ errors.first('instituteChiefID') }}</span>

        <div class="flex flex-wrap mt-4">
          <div class="w-1/2">
            <vs-input class="w-full" label="* 우편번호" disabled v-model="institute_data.zipCode" v-validate="'required'" name="zipCode" />
            <span class="text-danger text-sm" v-show="errors.has('zipCode')">{{ errors.first('zipCode') }}</span>
          </div>
          <div class="w-1/2">
            <vs-button class="mt-5 ml-4" @click="popupActive=true">주소 검색</vs-button>
          </div>
        </div>
      
        <vs-input class="w-full mt-4" label="* 주소" disabled v-model="institute_data.zipName" v-validate="'required'" name="zipName" />
        <span class="text-danger text-sm" v-show="errors.has('zipName')">{{ errors.first('zipName') }}</span>

        <vs-input class="w-full mt-4" label="주소세부" v-model="institute_data.zipDetail" name="zipDetail" />
        <span class="text-danger text-sm" v-show="errors.has('zipDetail')">{{ errors.first('zipDetail') }}</span>

        <!-- <div class="mt-4">
          <label class="text-sm">가맹 계약일</label>
          <datepicker @selected="formatterFrContractDate" :language="languages.ko" v-model="institute_data.frContractDate" format="yyyy-MM-dd"></datepicker>
          <span class="text-danger text-sm"></span>
        </div> -->

        <!-- <vs-input class="w-full mt-4" label="검색주소" v-model="institute_data.addressSearch" name="addressSearch" />
        <span class="text-danger text-sm" v-show="errors.has('addressSearch')">{{ errors.first('addressSearch') }}</span> -->
        
        <!-- <vs-input class="w-full mt-4" label="도메인" v-model="institute_data.domain" name="domain" />
        <span class="text-danger text-sm" v-show="errors.has('domain')">{{ errors.first('domain') }}</span> -->

        <!-- <vs-input class="w-full mt-4" label="캠퍼스 특이사항 메모" v-model="institute_data.memo" name="memo" />
        <span class="text-danger text-sm" v-show="errors.has('memo')">{{ errors.first('memo') }}</span> -->
        
        <!-- <div class="mt-4">
          <label class="text-sm">홈페이지노출</label>
          <div class="mt-2">
            <vs-radio v-model="institute_data.displayChk" vs-value="Y" class="mr-4">보이게 함</vs-radio>
            <vs-radio v-model="institute_data.displayChk" vs-value="N" class="mr-4">안보이게 함</vs-radio>
          </div>
        </div> -->

        <!-- <div class="mt-4">
          <label class="text-sm">정보입력일</label>
          <flat-pickr disabled v-model="institute_data.createDate" :config="{ dateFormat: 'Y-m-d', maxDate: new Date() }" class="w-full" name="createDate" />
          <span class="text-danger text-sm"></span>
        </div> -->
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="confirmSaveChanges" :disabled="!validateForm">수정</vs-button>
          <!-- <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button> -->
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.go(-1)">취소</vs-button>
        </div>
      </div>
    </div>

    <!-- Daum 우편번호 서비스 -->
    <vs-popup class="holamundo" title="주소 검색" :active.sync="popupActive">
      <p>
        <vue-daum-postcode @complete="this.daumPostCode" />
      </p>
    </vs-popup>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import * as lang from 'vuejs-datepicker/src/locale'
import vSelect from 'vue-select'
import moment from 'moment'
import { VueDaumPostcode } from 'vue-daum-postcode'

import { putData } from '@/api/module'

export default {
  components: {
    vSelect,
    Datepicker,
    VueDaumPostcode
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      languages: lang,
      popupActive: false,
      institute_data: JSON.parse(JSON.stringify(this.data)),
      frContractDate: this.data.frContractDate
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    formatterFrContractDate (value) {
      
      const frContractDate = moment(value).format('YYYY-MM-DD')
      this.frContractDate = frContractDate
    },
    daumPostCode (value) {
      // console.log(`result: ${JSON.stringify(value)}`)
      this.institute_data.zipCode = value.zonecode
      this.institute_data.zipName = value.address

      this.popupActive = false
    },
    confirmSaveChanges () {
      //this.saveChanges()

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '학원 정보 수정',
        text: '저장 하시겠습니까?',
        accept: this.saveChanges,
        acceptText: '저장'
      })
    },
    async saveChanges () {
      if (!this.validateForm) return

      this.institute_data.frContractDate = this.frContractDate

      try {
        const { data } = await putData('institute', this.institute_data)     
        console.log(data)

        this.$router.go(-1)

        this.showSaveChangesSuccess()

      } catch (error) {
        console.log(error)

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    showSaveChangesSuccess () {
      this.$vs.notify({
        color: 'success',
        title: '학원 정보 수정',
        text: '저장 되었습니다.'
      })
    },
    reset_data () {
      this.institute_data = JSON.parse(JSON.stringify(this.data))
    }
  }
}
</script>
